import React from 'react';
import { styles, styleVars } from './Body.css';
import { Tag } from '../Tag/Tag';
import type { ContentCardProps } from '../ContentCard';
import { assignInlineVars } from '@vanilla-extract/dynamic';

export type BodyProps = Pick<
  ContentCardProps,
  'showTag' | 'tagProps' | 'heading' | 'headingSize' | 'content' | 'maxContentLines'
>;

export const Body = ({ showTag, tagProps, heading, headingSize, content, maxContentLines }: BodyProps) => {
  return (
    <>
      {showTag && tagProps ? <Tag {...tagProps} className={styles.tagContainer} /> : null}
      {heading
        ? React.createElement(
            headingSize === 'large' ? 'h2' : headingSize === 'medium' ? 'h4' : 'h5',
            { className: styles.heading, style: { fontSize: headingSize === 'small' ? '1.25rem' : undefined } },
            heading
          )
        : null}
      {content ? (
        <div
          className={styles.contentContainer}
          style={assignInlineVars({ [styleVars.maxContentLines]: `${maxContentLines}` })}
        >
          {typeof content === 'string' ? <p>{content}</p> : content}
        </div>
      ) : null}
    </>
  );
};
